module.exports = __webpack_public_path__ + "static/Symphonia6-0bc4b7855362c85b33e740ef1680fa86.webp";